// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__gCxaG","title":"style__title__bxzIK","description":"style__description__crdwk","component":"style__component__bGw0-"};